import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        promoText: String,
        link: String,
        userLogged: Boolean,
        joinText: String,
        loggedText: String,
    };

    connect() {
        this.render();
    }

    render() {
        this.element.innerHTML = `<a class="relative leading-3 group lg:container mx-auto px-4 md:pl-8 flex justify-between items-center h-12 upgrade-bar clear-both"
           aria-label="${this.promoTextValue}" href="${this.linkValue}">
            <span class="text-xxs sm:text-xs font-extrabold tracking-wide leading-none uppercase inline-block text-default">
              ${this.promoTextValue}
            </span>
            ${
                !this.userLoggedValue
                    ? `<div class="flex items-center justify-center rounded-3xl px-3 h-8 text-xs text-white leading-none font-extrabold tracking-wide bg-light/20 group-hover:bg-light/30 whitespace-nowrap">
                <span class="inline-block uppercase">${this.joinTextValue}</span>
            </div>`
                    : `<div class="flex items-center justify-center rounded-3xl w-44 h-8 text-xs text-white leading-none font-extrabold tracking-wide bg-light/20 group-hover:bg-light/30 uppercase px-1 text-center">
                ${this.loggedTextValue}
            </div>`
            }
        </a>`;
    }
}
